import React from "react";
import './scss/style.scss';

interface Props {
  loadingLabel: string;
  isOverlay: boolean;
  dataTestId?: string
}

const Spinner: React.FC<Props> = ({
  loadingLabel,
  isOverlay,
  dataTestId
}) => {
  return (
    <div data-testid={dataTestId}>

      {isOverlay && (
        <div className="custom-spinner" data-testid="overlay"/>
      )}

      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{loadingLabel}</span>
      </div>
    </div>
  );
};

export default Spinner;
